let PJQ = PJQ ? PJQ : {};

PJQ.helpers = {
    getMobileOS: function () {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "ios";
        }

        return null;
    },
    setViewport: function (content) {
        let existingViewport = document.getElementById('viewport');
        if (existingViewport != null) {
            existingViewport.remove();
        }

        let nameViewports = document.getElementsByName("viewport");
        if (nameViewports && nameViewports.length > 0) {
            for (let i = 0; i < nameViewports.length; i++) {
                if (typeof nameViewports[i].remove === 'function') {
                    nameViewports[i].remove();
                }
            }
        }

        if (content != null) {
            let viewPortTag = document.createElement('meta');
            viewPortTag.id = "viewport";
            viewPortTag.name = "viewport";
            viewPortTag.content = content;
            document.getElementsByTagName('head')[0].appendChild(viewPortTag);
        }
    },
    domReadyHelper: function () {
        if (typeof $ === 'function') {
            //Prevent main ASP.NET outer form from submitting
            //This fixes issues with refreshing when pressing enter on input fields
            $("#Form").submit(function (e) {
                e.preventDefault();
            });

            let $skinHeader = $('.skin-header'),
                $content = PJQ.app.$el;
            if (_.size($skinHeader) > 0) {
                $content.css({
                    top: $skinHeader.height(),
                    bottom: 0,
                    left: 0,
                    position: 'fixed',
                    'overflow-y': 'auto'
                });

                let $skinFooter = $('.skin-footer');
                if (_.size($skinFooter) > 0) {
                    $content.css('bottom', $skinFooter.height())
                }
            }

            window.getParameterByName = function (name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            };

            window.processUpload = function (uid, sid, folder) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'processupload',
                            value: uid
                        }
                    ], [
                        {
                            parameter: 'folderId',
                            value: folder
                        }
                    ]),
                    isApi2: true
                }).post().done(_.bind(function (response) {
                    jQuery('#dlg-uplc').click();
                    if (typeof FileUploadCallback === "function")
                        FileUploadCallback();
                }, this));
            };

            // create and populate a hidden form.
            $.extend({
                form: function (url, data, method) {
                    if (method == null)
                        method = 'POST';
                    if (data == null)
                        data = {};

                    let form = $('<form>').attr({
                        method: method,
                        action: url
                    }).css({
                        display: 'none'
                    });

                    let addData = function (name, data) {
                        if ($.isArray(data)) {
                            for (let i = 0; i < data.length; i++) {
                                let value = data[i];
                                addData(name + '[]', value);
                            }
                        } else if (typeof data === 'object') {
                            for (let key in data) {
                                if (data.hasOwnProperty(key)) {
                                    addData(name + '[' + key + ']', data[key]);
                                }
                            }
                        } else if (data != null) {
                            form.append($('<input>').attr({
                                type: 'hidden',
                                name: String(name),
                                value: String(data)
                            }));
                        }
                    };

                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            addData(key, data[key]);
                        }
                    }
                    return form.appendTo('body');
                }
            });

            if (typeof $.ui === 'object') {

                if (typeof $.ui.dialog === 'function') {
                    $.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, {
                        _title: function (title) {
                            if (!this.options.title) {
                                title.html("&#160;");
                            } else {
                                title.html(this.options.title);
                            }
                        }
                    }));
                }

                if (typeof $.views === 'object') {
                    $.views.helpers({
                        formatPhone: function (val) {
                            if (val.length == 10)
                                return val.substring(0, 3) + '-' + val.substring(3, 6) + '-' + val.substring(6);
                            else
                                return val;
                        },

                        formatNewsfeedName: function (val) {
                            var temp = val.substring(val.indexOf('{') + 1);
                            return temp.substring(0, temp.indexOf('|'));
                        },

                        formatNewsfeed: function (val) {
                            if (val.indexOf('}') != -1) {
                                var temp = val.substring(val.lastIndexOf('}') + 1);
                                return temp;
                            } else
                                return val;
                        },

                        formatDate: function (jsonDate) {
                            var date = new Date(parseInt(jsonDate.substr(6)));
                            return dateFormat(date, 'dddd, mmmm d, yyyy @ h:MM:ss TT Z');
                        },

                        parseDate: function (myDate) {
                            if (!myDate || myDate.toLowerCase() === 'n/a')
                                return 'N/A';

                            var date = new Date(myDate);
                            return dateFormat(date, 'mm/dd/yyyy');
                        },

                        isTooOld: function (jsonDate) {
                            if (!jsonDate)
                                return true;
                            var createdOn = new Date(parseInt(jsonDate.substr(6)));
                            return ((((new Date() - createdOn) % 86400000) % 3600000) / 60000 > 5);
                        },

                        parseDateDT: function (myDate) {
                            if (!myDate || myDate.trim().length == 0) {
                                return '';
                            }
                            if (myDate.indexOf(' ') != -1)
                                myDate = myDate.substring(0, myDate.indexOf(' '));

                            var date = new Date(myDate);
                            return PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE);
                        },
                        parseTimeDT: function (myDate) {
                            if (!myDate)
                                return '';
                            if (myDate.indexOf('AM') == -1 && myDate.indexOf('PM') == -1)
                                return '';
                            return myDate.substring(myDate.indexOf(' ') + 1);
                        },
                        isLast: function () {
                            return this.index == this.parent.data.length - 1;
                        },
                        notLast: function () {
                            return this.index !== this.parent.data.length - 1;
                        }
                    });
                }
            }

            if (typeof $.blueimp === 'object') {
                $.blueimp.fileupload.prototype._initProgressListener = function (options) {
                    var that = this,
                        xhr = options.xhr ? options.xhr() : jQuery.ajaxSettings.xhr();
                    if (xhr.upload) {
                        jQuery(xhr.upload).bind('progress', function (e) {
                            var oe = e.originalEvent;
                            // Make sure the progress event properties get copied over:
                            e.lengthComputable = oe.lengthComputable;
                            e.loaded = oe.loaded;
                            e.total = oe.total;
                            that._onProgress(e, options);
                        });
                        options.xhr = function () {
                            return xhr;
                        };
                    }
                };
            }
        }
    }
};

PJQ.helpers.dateHelpers = {
    dateFormats: {
        URL_DATE: 'MM-dd-yyyy',
        DATE_TIME: "MM/dd/yyyy hh:mm TT",
        TIME: "hh:mm TT",
        DATE: "MM/dd/yyyy",
        DATE_MONTH_DAY: "MM/dd",
        DATE_YMD: "yyyy-MM-dd",
        MONTH_YEAR: 'MMMM yyyy',
        MONTH_DAY_SHORT: 'MMM dd',
        datePicker: {
            DATE_TIME: "MM/DD/YYYY hh:mm A",
            DATE: "MM/DD/YYYY",
            ALT_DATE: "MM-DD-YYYY"
        }
    },
    getTimezoneByOffset: function (offset) {
        for (let timezone in this.timezones) {
            if (this.timezones[timezone].offset === offset) {
                return timezone;
            }
        }
        return null;
    },
    getFormattedTimezoneOffset: function (offset) {
        let tzo = offset * 60,
            dif = tzo >= 0 ? '+' : '-',
            pad = function (num) {
                return (num < 10 ? '0' : '') + num;
            };
        return dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    },
    timezones: {
        ACST: {name: "AUS Central Standard Time", abbr: "ACST", offset: 9.5},
        ADT: {name: "Azerbaijan Standard Time", abbr: "ADT", offset: 5},
        AEST: {name: "AUS Eastern Standard Time", abbr: "AEST", offset: 10},
        AKDT: {name: "Alaskan Standard Time", abbr: "AKDT", offset: -8},
        AST: {name: "Afghanistan Standard Time", abbr: "AST", offset: 4.5},
        BST: {name: "Bangladesh Standard Time", abbr: "BST", offset: 6},
        CAST: {name: "Cen. Australia Standard Time", abbr: "CAST", offset: 9.5},
        CBST: {name: "Central Brazilian Standard Time", abbr: "CBST", offset: -4},
        CST: {name: "Central Standard Time", abbr: "CST", offset: -6},
        CDT: {name: "Central Daylight Time", abbr: "CDT", offset: -5},
        CEDT: {name: "Central European Standard Time", abbr: "CEDT", offset: 2},
        CPST: {name: "Central Pacific Standard Time", abbr: "CPST", offset: 11},
        CVST: {name: "Cape Verde Standard Time", abbr: "CVST", offset: -1},
        DST: {name: "Dateline Standard Time", abbr: "DST", offset: -12},
        EAST: {name: "E. Australia Standard Time", abbr: "EAST", offset: 10},
        EDT: {name: "Eastern Daylight Time", abbr: "EST", offset: -4},
        EST: {name: "Eastern Standard Time", abbr: "EST", offset: -5},
        EEDT: {name: "E. Europe Standard Time", abbr: "EEDT", offset: 3},
        ESAST: {name: "E. South America Standard Time", abbr: "ESAST", offset: -3},
        FDT: {name: "FLE Standard Time", abbr: "FDT", offset: 3},
        FST: {name: "Fiji Standard Time", abbr: "FST", offset: 12},
        GDT: {name: "GTB Standard Time", abbr: "GDT", offset: 3},
        GET: {name: "Georgian Standard Time", abbr: "GET", offset: 4},
        GMT: {name: "GMT Standard Time", abbr: "GMT", offset: 0},
        GST: {name: "Greenwich Standard Time", abbr: "GST", offset: 0},
        HST: {name: "Hawaiian Standard Time", abbr: "HST", offset: -10},
        IDT: {name: "Iran Standard Time", abbr: "IDT", offset: 4.5},
        IST: {name: "India Standard Time", abbr: "IST", offset: 5.5},
        JDT: {name: "Israel Standard Time", abbr: "JDT", offset: 3},
        JST: {name: "Japan Standard Time", abbr: "JST", offset: 9},
        KDT: {name: "Kamchatka Standard Time", abbr: "KDT", offset: 13},
        KST: {name: "Korea Standard Time", abbr: "KST", offset: 9},
        LST: {name: "Libya Standard Time", abbr: "LST", offset: 2},
        MEDT: {name: "Middle East Standard Time", abbr: "MEDT", offset: 3},
        MPST: {name: "Singapore Standard Time", abbr: "MPST", offset: 8},
        MSK: {name: "Moscow Standard Time", abbr: "MSK", offset: 3},
        MDT: {name: "Mountain Daylight Time", abbr: "MDT", offset: -6},
        MST: {name: "Mountain Standard Time", abbr: "MST", offset: -7},
        NAEST: {name: "North Asia East Standard Time", abbr: "NAEST", offset: 8},
        NAST: {name: "North Asia Standard Time", abbr: "NAST", offset: 8},
        NCAST: {name: "N. Central Asia Standard Time", abbr: "NCAST", offset: 7},
        NDT: {name: "Newfoundland Standard Time", abbr: "NDT", offset: -2.5},
        NST: {name: "Nepal Standard Time", abbr: "NST", offset: 5.75},
        NZST: {name: "New Zealand Standard Time", abbr: "NZST", offset: 12},
        PDT: {name: "Pacific Daylight Time", abbr: "PDT", offset: -7},
        PKT: {name: "Pakistan Standard Time", abbr: "PKT", offset: 5},
        PSST: {name: "Pacific SA Standard Time", abbr: "PSST", offset: -4},
        PST: {name: "Pacific Standard Time", abbr: "PST", offset: -8},
        PYT: {name: "Paraguay Standard Time", abbr: "PYT", offset: -4},
        RDT: {name: "Romance Standard Time", abbr: "RDT", offset: 2},
        SAMT: {name: "Samara Time", abbr: "SAMT", offset: 4},
        SAST: {name: "SE Asia Standard Time", abbr: "SAST", offset: 7},
        SDT: {name: "Syria Standard Time", abbr: "SDT", offset: 3},
        SEST: {name: "SA Eastern Standard Time", abbr: "SEST", offset: -3},
        SLST: {name: "Sri Lanka Standard Time", abbr: "SLST", offset: 5.5},
        SPST: {name: "SA Pacific Standard Time", abbr: "SPST", offset: -5},
        SST: {name: "Samoa Standard Time", abbr: "SST", offset: 13},
        SWST: {name: "SA Western Standard Time", abbr: "SWST", offset: -4},
        TDT: {name: "Turkey Standard Time", abbr: "TDT", offset: 3},
        TST: {name: "Tonga Standard Time", abbr: "TST", offset: 13},
        UST: {name: "Ulaanbaatar Standard Time", abbr: "UST", offset: 8},
        UTC: {name: "UTC", abbr: "UTC", offset: 0},
        VST: {name: "Vladivostok Standard Time", abbr: "VST", offset: 11},
        WAST: {name: "W. Australia Standard Time", abbr: "WAST", offset: 8},
        WCAST: {name: "W. Central Africa Standard Time", abbr: "WCAST", offset: 1},
        WEDT: {name: "W. Europe Standard Time", abbr: "WEDT", offset: 2},
        WPST: {name: "West Pacific Standard Time", abbr: "WPST", offset: 10},
        YEKT: {name: "Yekaterinburg Time", abbr: "YEKT", offset: 5},
        YST: {name: "Yakutsk Standard Time", abbr: "YST", offset: 9},
    },
    parseDateString(input, isUTC = true) {
        return _.size(input) > 0 ? (new Date(isUTC || input.indexOf('Z') === -1 ? input : input.slice(0, -1))) : input;
    },
    GetDaysInMonth(m, y) {
        return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
    },
    tryParseDateString(string) {
        let result = new Date(string);
        if (Object.prototype.toString.call(result) === "[object Date]") {
            if (isNaN(result.getTime())) {
                return null;
            } else {
                return result;
            }
        } else {
            return null;
        }
    },
    getDayName: function (dayNumber) {
        // Pass number 0-6 to get the day name. 0 = Sunday, 6 = Saturday
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        if (dayNumber < 0 || dayNumber > 6) {
            return "Invalid day number";
        }

        return dayNames[dayNumber];
    },
    getWeekBounds: function (date) {
        // localDate is here because setUTCDate was changing the original date to the end date
        let localDate = new Date(date),
            startDiff = localDate.getUTCDate() - localDate.getUTCDay(),
            endDiff = localDate.getUTCDate() + (6 - localDate.getUTCDay());
        return {
            start: new Date(localDate.setUTCDate(startDiff)),
            end: new Date(localDate.setUTCDate(endDiff))
        };
    },
    getCurrentMonth: function () {
        return (new Date()).getMonth() + 1;
    },
    getCurrentYear: function () {
        return (new Date()).getFullYear();
    },
    getTimeStats: function (date1, date2) {
        let t = Date.parse(date1) - Date.parse(date2),
            totalSeconds = Math.floor((t / PJQ.constants.time.millis.ONE_MINUTE)),
            seconds = Math.floor(totalSeconds % 50),
            totalMinutes = Math.floor((t / 1000 / 60)),
            minutes = Math.floor(totalMinutes % 60),
            totalHours = Math.floor((t / (PJQ.constants.time.millis.ONE_HOUR))),
            hours = Math.floor(totalHours % 24),
            totalDays = Math.floor(t / (PJQ.constants.time.millis.ONE_DAY)),
            days = Math.floor(totalDays % 30),
            totalMonths = Math.floor(t / (PJQ.constants.time.millis.ONE_MONTH)),
            months = Math.floor(totalMonths % 12),
            years = Math.floor(t / (PJQ.constants.time.millis.ONE_YEAR));
        return {
            years: years,
            months: months,
            totalMonths: totalMonths,
            days: days,
            totalDays: totalDays,
            hours: hours,
            totalHours: totalHours,
            minutes: minutes,
            totalMinutes: totalMinutes,
            seconds: seconds,
            totalSeconds: totalSeconds,
            totalMillis: t
        };
    },
    getTimeString: function (date) {
        if (date == null) {
            return '';
        }

        let timeArray = date.toLocaleTimeString('en-US', {hour12: false}).split(':');

        // If timeArray[0] is 24 (12AM) we want to set it to 0
        timeArray[0] = timeArray[0] < 24 ? timeArray[0] : 0;

        // If timeArray[0] is single digit, we want to prepend a 0 to that.
        timeArray[0] = timeArray[0] < 10 ? '0' + timeArray[0] : timeArray[0];

        // Build time string from timeArray
        return `${timeArray[0]}:${timeArray[1]}:${timeArray[2]}`;
    },
    getMinutesFromHoursDecimal: function (hoursDecimal) {
        // This function expects hours to be in decimal form.
        // An example for this function would be: (Input : 11.08 => Output: 665)
        let wholeHours = Math.floor(hoursDecimal);
        let fractionalHours = hoursDecimal - wholeHours;
        let minutesFromFraction = fractionalHours * 60;

        return (wholeHours * 60) + Math.round(minutesFromFraction);
    },
    getCountdownString: function (date) {
        date = this.getTimeStats(date, new Date());
        let s = "";
        if (date.days > 0)
            s += (date.days + "d ");
        if (date.hours > 0 || date.days > 0)
            s += (date.hours + "h ");
        if (date.minutes > 0 || date.hours > 0 || date.days > 0)
            s += (date.minutes + "m ");

        s += (date.seconds + "s");
        return s;
    },
    checkDateIsBeforeToday: function (date) {
        if (!date) {
            return true;
        }

        let argDate = new Date(date);
        argDate.setHours(0, 0, 0, 0);
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        return argDate < today;
    },
    checkDateBetweenDays: function (date1, date2, checkDate = new Date()) {
        return (checkDate.getTime() <= date2.getTime() && checkDate.getTime() >= date1.getTime());
    },
    checkDateRangesOverlap: function (startA, endA, startB, endB) {
        startA = new Date(startA);
        endA = new Date(endA);
        startB = new Date(startB);
        endB = new Date(endB);
        if (startA <= startB && startB <= endA) return true; // b starts in a
        if (startA <= endB && endB <= endA) return true; // b ends in a
        if (startB < startA && endA < endB) return true; // a in b
        return false;
    },
    getFromNowString: function (date) {
        return moment(new Date(date)).fromNow();
    },
    getTimeElapsed: function (date) {
        return this.getTimeStats(new Date(), date);
    },
    getTimeRemaining: function (date) {
        return this.getTimeStats(date, new Date());
    },
    getNewDateAddMilliseconds: function (date, milliseconds) {
        if (!date)
            return date;
        else {
            date = new Date(date);
            return new Date(date.setTime(date.getTime() + milliseconds));
        }
    },
    getNewDateAddSeconds: function (date, seconds) {
        return this.getNewDateAddMilliseconds(date, seconds * 1000);
    },
    getNewDateAddHours: function (date, hours) {
        return this.getNewDateAddMilliseconds(date, hours * PJQ.constants.time.millis.ONE_HOUR);
    },
    getNewDateAddDays: function (date, days, weekdaysOnly = false, inclusive = false) {
        days -= (inclusive ? 1 : 0);
        if (weekdaysOnly) {
            let result = new Date(date);
            let day = result.getDay();
            result.setDate(
                result.getDate() + days +
                (day === 6 ? 2 : +!day) +
                (Math.floor((days - 1 + (day % 6 || 1)) / 5) * 2));
            return result;
        }
        return this.getNewDateAddMilliseconds(date, days * PJQ.constants.time.millis.ONE_DAY);
    },
    getDateMillisecondsDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'milliseconds');
    },
    getDateSecondsDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'seconds');
    },
    getDateMinutesDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'minutes');
    },
    getDateHoursDiff: function (date1, date2) {
        return this.getDateDiff(date1, date2, 'hours');
    },
    getDateDaysDiff: function (date1, date2, weekdaysOnly, inclusive = false) {
        if (weekdaysOnly) {
            let numWorkDays = 0,
                currentDate = new Date(date2);
            while (currentDate <= date1) {
                // Skips Sunday and Saturday
                if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                    numWorkDays++;
                }
                currentDate = currentDate.addDays(1);
            }
            return numWorkDays;
        }

        return this.getDateDiff(date1, date2, 'days') + (inclusive ? 1 : 0);
    },
    getDateDiff: function (date1, date2, type) {
        date1 = date1 == null ? new Date() : date1;
        date2 = date2 == null ? new Date() : date2;
        let diff = parseInt(date1.getTime() - date2.getTime()),
            result = 0;
        switch (type) {
            case 'days':
                result = diff / PJQ.constants.time.millis.ONE_DAY;
                break;
            case 'hours':
                result = diff / PJQ.constants.time.millis.ONE_HOUR;
                break;
            case 'minutes':
                result = diff / PJQ.constants.time.millis.ONE_MINUTE;
                break;
            case 'seconds':
                result = diff / PJQ.constants.time.millis.ONE_SECOND;
                break;
            default:
                result = diff;
                break;
        }
        result = Math.floor(isNaN(result) ? 0 : result);
        return result;
    },
    checkTimesDifferent: function (date1, date2, isIncludeSeconds = false) {
        return date1.getHours() !== date2.getHours() ||
            date1.getMinutes() !== date2.getMinutes() ||
            (isIncludeSeconds && date1.getSeconds() !== date2.getSeconds());
    },
    getDateDiffString: function (compareDate) {
        let date = new Date(),
            totalMinutes = this.getDateMinutesDiff(compareDate ? compareDate : date, date),
            hours = Math.floor(totalMinutes / 60),
            minutes = totalMinutes % 60;
        if (hours > 0)
            return (hours + 'hrs ' + minutes + 'min');
        else
            return (minutes + 'min');
    },
    validateDate: function (dateString, type) {
        dateString = dateString.replace(/-/g, '/');

        // Parse the date parts to integers
        let parts = dateString.split("/"),
            day = 0,
            month = 0,
            year = 0;

        if (type == null || type == '' || type.toLowerCase() == 'mdy') {
            if (/^\d{1,2}?\/\d{1,2}?\/\d{4}?$/i.test(dateString) == false)
                return false;
            month = parseInt(parts[0], 10);
            day = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
        } else if (type.toLowerCase() == 'dmy') {
            if (/^\d{1,2}?\/\d{1,2}?\/\d{4}?$/i.test(dateString) == false)
                return false;
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
        } else if (type.toLowerCase() == 'ymd') {
            if (/^\d{4}?\/\d{1,2}?\/\d{1,2}?$/i.test(dateString) == false)
                return false;

            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            day = parseInt(parts[2], 10);
        }

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    },
    getDateString: function (date, Z, utc) {
        let format = Z;
        if (date == null || (PJQ.helpers.objectHelpers.refinedType(date) === 'date' && isNaN(date.getTime())))
            return;
        else if (typeof date === 'string') {
            if (date.trim().length === 0) {
                return;
            }
            date = new Date(date);
        }

        let MMMM = ["\x00", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            MMM = ["\x01", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dddd = ["\x02", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        function ii(i, len) {
            let s = i + "";
            len = len || 2;
            while (s.length < len) s = "0" + s;
            return s;
        }

        let y = utc ? date.getUTCFullYear() : date.getFullYear();
        format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
        format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
        format = format.replace(/(^|[^\\])y/g, "$1" + y);

        let M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
        format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
        format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
        format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
        format = format.replace(/(^|[^\\])M/g, "$1" + M);

        let d = utc ? date.getUTCDate() : date.getDate();
        format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
        format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
        format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
        format = format.replace(/(^|[^\\])d/g, "$1" + d);

        let H = utc ? date.getUTCHours() : date.getHours();
        format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
        format = format.replace(/(^|[^\\])H/g, "$1" + H);

        let h = H > 12 ? H - 12 : H == 0 ? 12 : H;
        format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
        format = format.replace(/(^|[^\\])h/g, "$1" + h);

        let m = utc ? date.getUTCMinutes() : date.getMinutes();
        format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
        format = format.replace(/(^|[^\\])m/g, "$1" + m);

        let s = utc ? date.getUTCSeconds() : date.getSeconds();
        format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
        format = format.replace(/(^|[^\\])s/g, "$1" + s);

        let f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
        format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
        f = Math.round(f / 10);
        format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
        f = Math.round(f / 10);
        format = format.replace(/(^|[^\\])f/g, "$1" + f);

        let T = H < 12 ? "AM" : "PM";
        format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
        format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));

        let t = T.toLowerCase();
        format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
        format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));

        let tz = -date.getTimezoneOffset(),
            K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
        if (!utc) {
            tz = Math.abs(tz);
            let tzHrs = Math.floor(tz / 60),
                tzMin = tz % 60;
            K += ii(tzHrs) + ":" + ii(tzMin);
        }
        format = format.replace(/(^|[^\\])K/g, "$1" + K);

        let day = (utc ? date.getUTCDay() : date.getDay()) + 1;
        format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
        format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);

        format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
        format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);

        format = format.replace(/\\(.)/g, "$1");

        return format;
    }
};

PJQ.helpers.timerHelpers = {
    createCountdownTimer: function ($el, date, finishCallback) {
        if ($el) {
            let t = PJQ.helpers.dateHelpers.getTimeRemaining(date);
            this.createTimerElement($el, date);
            if (t.totalMillis > 0) {
                let interval = setInterval(_.bind(function () {
                    t = PJQ.helpers.dateHelpers.getTimeRemaining(date);
                    if (t.totalMillis > 0) {
                        this.createTimerElement($el, date);
                    } else {
                        clearInterval(interval);
                        if (finishCallback)
                            finishCallback($el);
                    }
                }, this), 1000);
            }
        }
        return interval;
    },
    createElapsedTimer: function ($el, date) {
        if ($el) {
            let t = PJQ.helpers.dateHelpers.getTimeElapsed(date);
            this.createTimerElement($el, date);
            let interval = setInterval(_.bind(function () {
                t = PJQ.helpers.dateHelpers.getTimeElapsed(date);
                this.createTimerElement($el, date);
            }, this), 1000);
        }
        return interval;
    },
    createTimerElement: function ($el, date) {
        $el.html(PJQ.helpers.dateHelpers.getCountdownString(date));
    }
};

PJQ.helpers.validators = {
    validatePhone: function (value) {
        return ((value.replace(/-/g, '').replace('(', '').replace(')', '').replace(' ', '').length >= 10) || value.replace('/', '').toLowerCase() === 'na');
    },
    validateZip: function (value) {
        return (/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(value) || (/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/).test(value);
    },
    validateEmail: function (emailAddress, isAllowMultiple = false) {
        let error = null,
            emailRegex = new RegExp("^[A-Z0-9._%'-]+\\+?[A-Z0-9]{0,20}@[A-Z0-9.-]+\\.[A-Z]{2,20}$", "i");
        if (isAllowMultiple) {
            if (emailAddress.indexOf(";") !== -1) {
                _.every(emailAddress.split(';'), function (emailIteration) {
                    emailIteration = emailIteration.replace(' ', '');
                    if (!emailIteration || !emailRegex.test(emailIteration)) {
                        error = "INVALID";
                        return false;
                    }
                    return true;
                });
            } else if (emailAddress.indexOf(",") !== -1) {
                _.every(emailAddress.split(','), function (emailIteration) {
                    emailIteration = emailIteration.replace(' ', '');
                    if (!emailIteration || !emailRegex.test(emailIteration)) {
                        error = "INVALID";
                        return false;
                    }
                    return true;
                });
            } else if (!emailRegex.test(emailAddress)) {
                error = "INVALID";
            }
        } else {
            if (emailAddress.indexOf(";") !== -1 || emailAddress.indexOf(",") !== -1) {
                error = "MULTIPLE";
            } else if (!emailRegex.test(emailAddress)) {
                error = "INVALID";
            }
        }
        return {
            success: error === null,
            error: error
        };
    }
};

PJQ.helpers.formatHelpers = {
    getOrdinalSuffix: function (value) {
        let j = value % 10,
            k = value % 100;
        if (j === 1 && k !== 11) {
            return value + "st";
        }
        if (j === 2 && k !== 12) {
            return value + "nd";
        }
        if (j === 3 && k !== 13) {
            return value + "rd";
        }
        return value + "th";
    },
    upperCaseFirstLetterEachWord: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    upperCaseFirstLetter: function (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    lowerCaseFirstLetter: function (value) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    },
    formatPhoneNumber: function (value, wrapURL) {
        let s2 = ("" + value).replace(/\D/g, ''),
            m = s2.match(/^(\d{3})(\d{3})(\d{4})$/),
            val = (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];

        if (wrapURL)
            val = '<a class="phone-link" href="tel:' + val + '">' + val + '</a>';

        return val;
    },
    numbersOnly: function (value, allowDecimals = false, allowNegative = false) {
        if (allowNegative)
            return value != null ? value.toString().replace(new RegExp('[^0-9\-]', 'g'), '') : "";
        else if (allowDecimals)
            return value != null ? value.toString().replace(new RegExp('[^0-9\.]', 'g'), '') : "";
        else
            return value != null ? value.toString().replace(new RegExp('[^0-9\]', 'g'), '') : "";
    },
    alphanumericOnly: function (value) {
        return value != null ? value.toString().replace(new RegExp('[^a-z0-9]', 'gi'), '') : "";
    },
    formatPercent: function (value) {
        let cleaned = '0';
        if (value != null) {
            cleaned = this.numbersOnly(value, true);
            if (isNaN(parseInt(cleaned))) {
                cleaned = '0'
            }
        }
        return cleaned + '%';
    },
    formatDecimal: function (number, decimals = 2) {
        if (number == null || isNaN(number))
            number = 0;
        return number.toFixed(decimals);
    },
    formatZip: function (value) {
        value = this.alphanumericOnly(value);
        if (_.size(value) === 6) {
            return value.substr(0, 3).toUpperCase() + '-' + value.substr(3, 6).toUpperCase();
        } else {
            return value;
        }
    },
    numberToWords: function (number) {
        // Works into the billions
        if (number === 0) return 'zero';

        const digits = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const tens = ['ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const scales = ['', 'thousand', 'million', 'billion'];

        let words = '';
        let scaleIndex = 0;

        while (number > 0) {
            const current = number % 1000;
            number = Math.floor(number / 1000);

            if (current === 0) {
                continue;
            }

            let currentWords = '';
            if (current >= 100) {
                currentWords += digits[Math.floor(current / 100) - 1] + ' hundred';
            }

            if (current % 100 < 10) {
                currentWords += (currentWords.length && current % 100 !== 0 ? ' ' : '') + digits[current % 100 - 1];
            } else if (current % 100 < 20) {
                currentWords += (currentWords.length ? ' ' : '') + teens[(current % 100) - 11];
            } else {
                currentWords += (currentWords.length ? ' ' : '') + tens[Math.floor((current % 100) / 10) - 1];
                if (current % 10 !== 0) {
                    currentWords += '-' + digits[current % 10 - 1];
                }
            }

            words = currentWords + (currentWords.length ? ' ' + scales[scaleIndex] + ' ' : '') + words;
            scaleIndex++;
        }

        return words.trim();
    },
    minutesToHHMM: function (minutes) {
        let hours = Math.floor(minutes / 60),
            mins = minutes % 60;
        return (hours < 10 ? '0' : '') + hours + ':' + (mins < 10 ? '0' : '') + mins;
    },
    minutesFromHHMM: function (timeStr) {
        if (timeStr == null || _.size(timeStr) === 0)
            return 0;

        let parts = timeStr.split(':');
        return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    },
    formatCurrency: function (money, decimals = 2, includeDollarSign = true) {
        if (money == null || isNaN(money))
            money = 0;
        return (includeDollarSign ? '$' : '') + (money / 100).toFixed(decimals).toString().replace(PJQ.constants.regex.CURRENCY_NO_SYMBOL, '$1,');
    },
    getCentsDisplay: function (money) {
        return money % 100 < 10 ? '0' + (money % 100).toString() : (money % 100).toString();
    },
    getDollarsDisplay: function (money) {
        return Math.floor(money / 100).toString()
    },
    getTotalCents: function (dollars, cents) {
        if (typeof dollars === 'string')
            dollars = parseInt(dollars);
        else if (typeof dollars != 'number')
            dollars = 0;
        dollars *= 100;

        if (typeof cents === 'string')
            cents = parseInt(cents);
        else if (typeof cents != 'number')
            cents = 0;

        if (dollars < 0)
            cents *= -1;

        return dollars + cents;
    },
    convertNLtoBR: function (input) {
        if (typeof input === 'string')
            return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
        else
            return input;
    }
};

PJQ.helpers.inputHelpers = {
    getMoneyInputValue: function ($container) {
        let inputDollarsFull = $container.find('.input-dollars-full');
        if (_.size(inputDollarsFull) === 0 && $container.hasClass('input-dollars-full')) {
            inputDollarsFull = $container;
        } else if ($container.hasClass('input-decimal')) {
            inputDollarsFull = $container;
        }

        let total = 0;
        if (_.size(inputDollarsFull) > 0) {
            let inputVal = inputDollarsFull.val(),
                inputSplit = inputVal.toString().split('.');
            if (inputSplit.length < 2) {
                inputSplit[1] = "00";
            } else if (inputSplit[1].trim().length === 1) {
                inputSplit[1] = inputSplit[1] + "0";
            } else if (inputSplit[1].trim().length === 0) {
                inputSplit[1] = "00";
            }
            total = parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1], true, true));
        } else {
            let dollarsInput = $container.find('.input-dollars'),
                centsInput = $container.find('.input-cents'),
                dollars = _.size(dollarsInput) > 0 ? dollarsInput.val() : "0",
                cents = "00";

            if (_.size(centsInput) > 0) {
                //If both inputs are blank, we return null so we set null instead of 0 in the database
                if (_.size(dollarsInput.val()) === 0 && _.size(centsInput.val()) === 0) {
                    return null;
                }

                cents = centsInput.val();
                if (_.size(cents) < 2)
                    cents = ((_.size(cents) === 1 ? '0' : '00') + cents.toString());
            } else if (_.size(dollarsInput.val()) === 0) {
                //If dollars is blank, we return null so we set null instead of 0 in the database
                return null;
            }
            total = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(dollars, false, true) + PJQ.helpers.formatHelpers.numbersOnly(cents));
        }
        return isNaN(total) ? 0 : total;
    },
    getNumberInputValue: function ($el) {
        let num = parseInt(PJQ.helpers.formatHelpers.numbersOnly($el.val(), false, true));
        return isNaN(num) ? null : num;
    },
    getPercentInputValue: function ($el, decimal = false) {
        let inputVal = $el.val().replace('%', '');
        if (inputVal === "") {
            return inputVal;
        }

        let inputSplit = inputVal.toString().split('.');
        if (inputSplit.length < 2) {
            inputSplit[1] = "00";
        } else if (inputSplit[1].trim().length === 1) {
            inputSplit[1] = inputSplit[1] + "0";
        } else if (inputSplit[1].trim().length === 0) {
            inputSplit[1] = "00";
        }

        if (decimal) {
            return parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1])) / 100;
        } else {
            return parseInt(PJQ.helpers.formatHelpers.numbersOnly(inputSplit[0] + inputSplit[1]));
        }
    },
    getPhoneInputValue: function ($el) {
        return PJQ.helpers.formatHelpers.numbersOnly($el.val())
    },
    getElementNodeType: function (input) {
        return input.prop('nodeName').toLowerCase();
    },
    attachNumericInputMinMax: function ($el, min, max, callback) {
        $el.on('change', function () {
            let val = $el.val();
            if (min && min > val)
                val = min;
            else if (max && max < val)
                val = max;
            $el.val(val);

            if (typeof callback === 'function') {
                callback(val);
            }
        });
    },
    inputMaxLength: function (e, length) {
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: . if allowPeriods == true
            (e.keyCode == 190 && allowPeriods) ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        if ($(e.currentTarget).val().length >= (isNaN(length) ? 1 : length))
            e.preventDefault();
    },
    numbersOnly: function (e, allowPeriods = false, allowNegative = false) {
        if (e.type === 'keyup') {
            let $target = $(e.target);
            $target.val(PJQ.helpers.formatHelpers.numbersOnly($target.val()));
        } else {
            // Allow: backspace, delete, tab, escape, and enter
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: . if allowPeriods == true
                ((e.keyCode === 190 || e.keyCode === 110) && allowPeriods) ||
                //Allow - if allowNegative == true
                ((e.keyCode === 109 || e.keyCode === 189) && allowNegative) ||
                // Allow: Ctrl/cmd+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+C
                (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+X
                (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl/cmd+V
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // Key that was pressed is allowed
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        }
    },
    numbersAndSingleDecimalOnly: function (e) {
        return this.numbersOnly(e, true);
    },
    allowZip: function (e, country) {
        country = country != null && country.toLowerCase() === 'ca' ? 'ca' : 'us';
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: . if allowPeriods == true
            (e.keyCode == 190 && allowPeriods) ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if (country === 'us' && (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

        if ($(e.currentTarget).val().replace('-', '').length >= (country === 'ca' ? 7 : 5))
            e.preventDefault();
    },
    setInputError: function (input, isValid = false, options = {}) {
        if (input == null || input.length <= 0)
            return;

        let elementType = this.getElementNodeType(input);
        if (elementType === 'input' || elementType === 'textarea') {
            if (isValid) {
                input.removeClass('p-field-error');
            } else {
                if (options.isHighlightInput != false) {
                    input.addClass('p-field-error');
                }
            }
        } else if (elementType === 'select') {
            let inputButton = input.siblings('.dropdown-toggle').eq(0);
            if (inputButton.length > 0) {
                if (isValid) {
                    inputButton.removeClass('p-field-error');
                } else {
                    inputButton.addClass('p-field-error');
                }
            }
        } else if (input.hasClass('bootstrap-select')) {
            let inputButton = input.find('.dropdown-toggle');
            if (inputButton.length > 0) {
                if (isValid) {
                    inputButton.removeClass('p-field-error');
                } else {
                    inputButton.addClass('p-field-error');
                }
            }
        }

        //Delete the existing error text if it exists
        let errId = input.data('errSrc');
        if (_.size(errId) > 0) {
            $('div[data-err="' + errId + '"]').remove();
            input.removeData('errSrc');
        }

        if (_.size(options.errorText) > 0) {
            let $errorEl;
            if (elementType === 'select') {
                $errorEl = input.closest('.btn-group');
            } else {
                $errorEl = input.closest('.input-group');
            }

            if (_.size($errorEl) === 0) {
                $errorEl = input.closest('.form-group').find('label');

                if (_.size($errorEl) > 0) {
                    $errorEl.append($('<span>', {
                        'class': 'fs-14 text-danger ml-1 wd-100 font-weight-light ml-2'
                    }).html(options.errorText));
                }
            } else {
                //Add the new error text
                errId = _.uniqueId();
                input.data('errSrc', errId);
                $errorEl.append($('<div>', {
                    'class': 'fs-14 text-danger ml-1 wd-100 font-weight-light',
                    'data-err': errId
                }).html(options.errorText));
            }


            if (_.size($errorEl) > 0) {

            }
        }
    },
    inputMaskPhone: function (input) {
        input.inputmask('(999) 999-9999', {
            placeholder: ''
        });
    },
    inputMaskZip: function (input, country = 'us') {
        input.inputmask(country && country.toLowerCase() == 'ca' ? 'A9A-9A9' : '99999', {
            placeholder: ''
        });
    },
    inputMaskCurrency: function (input, digits = 0, showSymbol = false) {
        input.inputmask({
            alias: "currency",
            prefix: showSymbol ? '$' : '',
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false,
            allowMinus: true
        });
    },
    inputMaskHours: function (input) {
        input.inputmask('99:59', {
            mask: "99:59",
            placeholder: "00:00",
            definitions: {
                '9': {
                    validator: "[0-9]",
                    cardinality: 1
                },
                '5': {
                    validator: "[0-5]",
                    cardinality: 1
                }
            },
            insertMode: false,
            showMaskOnHover: false,
            positionCaretOnClick: 'select'
        }).off("focus.tei").on("focus.tei", function () {
            this.setSelectionRange(0, 1);
        }).on("input", function () {
            // The colon will always be at position 2, so we always want to skip over it.
            let caretPos = this.selectionStart;

            if (caretPos === 2) {
                this.setSelectionRange(3, 4);
            }
        });
    },
    inputMaskPercent: function (input, digits = 0, showSymbol = false) {
        input.inputmask({
            alias: "currency",
            suffix: showSymbol ? '%' : '',
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false,
            allowMinus: true
        });
    },
    inputMaskCreditCard: function (input, digits = 0) {
        input.inputmask('9999 9999 9999 9999', {
            alias: "cc",
            digits: digits,
            placeholder: '',
            rightAlign: false
        });
    },
    inputMaskDecimal: function (input, digits = 0) {
        input.inputmask({
            alias: "currency",
            prefix: "",
            digits: digits,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });
    },
    inputMaskInteger: function (input) {
        //we use currency so we get commas
        input.inputmask({
            alias: "currency",
            prefix: "",
            digits: 0,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });
    }
};

PJQ.helpers.bidForms = {
    lineItemTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    lineItemQuestionTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Numeric",
        "Date",
        "Date/Time"
    ],
    alternateTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    alternateQuestionTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    acknowledgementTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    bondingTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    certificationTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    laborRateTypes: [
        "Yes/No",
        "Text",
        "Textarea",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ]
};

PJQ.helpers.guid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

PJQ.helpers.stringHelpers = {
    format: function (format) {
        let args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    },
    getLowercaseChars: function (string) {
        return string.match(/[a-z]/g);
    },
    getUppercaseChars: function (string) {
        return string.match(/[A-Z]/g);
    },
    getNumericChars: function (string) {
        return string.match(/[\d]/g);
    },
    getSpecialChars: function (string) {
        return string.match(/[^a-zA-Z\d]/g);
    },
    findMatches: function (regex, str, matches = []) {
        const res = regex.exec(str);
        res && matches.push({
            full: res[0],
            group: res[1]
        }) && this.findMatches(regex, str, matches);
        return matches;
    }
};

PJQ.helpers.objectHelpers = {
    checkNested: function (obj, level, ...rest) {
        if (typeof obj === 'undefined' || obj == null)
            return false;
        else if (_.size(rest) === 0 && obj.hasOwnProperty(level))
            return true;
        return this.checkNested(obj[level], ...rest);
    },
    getNestedValue: function (obj, attr) {
        if (attr == null || obj == null) {
            return null;
        }

        let attrs = attr.split('.');
        return attrs.reduce((acc, val) => acc && acc[val], obj);
    },
    convertObjectCamelcase: function (copyObject, destinationObject = {}) {
        if (typeof copyObject === "string") {
            return copyObject.substring(0, 1).toLowerCase() + copyObject.substring(1);
        } else if (copyObject instanceof Array) {
            return _.map(copyObject, function (value) {
                if (typeof value === "object") {
                    value = this.convertObjectCamelcase(value)
                }
                return value
            }, this);
        } else {
            _.each(copyObject, function (value, key) {
                if (copyObject.hasOwnProperty(key)) {
                    let valueType = this.refinedType(value),
                        lowerKey = key.substring(0, 1).toLowerCase() + key.substring(1);
                    if (valueType === 'object' || valueType === 'array') {
                        destinationObject[lowerKey] = this.convertObjectCamelcase(value);
                    } else {
                        destinationObject[lowerKey] = value;
                    }
                }
            }, this);
        }
        return destinationObject;
    },
    refinedType: function (object, isIncludeBackbone) {
        if (typeof object === 'object') {
            if (Object.prototype.toString.call(object) === '[object Array]') {
                return 'array';
            } else if (object instanceof Date) {
                return 'date';
            } else if (isIncludeBackbone) {
                if (this.isBackboneModel(object))
                    return 'backboneModel';
                else if (this.isBackboneCollection(object))
                    return 'backboneCollection';
            }
        }
        return typeof object;
    },
    isBackboneModel: function (object) {
        return object instanceof Backbone.Model;
    },
    isBackboneCollection: function (object) {
        return object instanceof Backbone.Collection;
    },
    findDistinct: function (arr, property) {
        let result = [],
            isBackboneCollection = this.isBackboneCollection(arr),
            isBackboneModels = isBackboneCollection || this.isBackboneModel(arr[0]);
        _.each(isBackboneCollection ? arr.models : arr, function (obj) {
            if (_.find(result, function (resultObj) {
                if (isBackboneModels)
                    return resultObj.get(property) === obj.get(property);
                else
                    return resultObj[property] === obj[property];
            }) == null) {
                result.push(obj);
            }
        });
        return result;
    }
};

PJQ.helpers.urlHelpers = {
    buildApiUrl: function (endpoint, options = {
        isPascal: false,
        includeSessionId: false,
        includeAccessKey: false,
        includeAccessToken: false,
        service: null
    }) {
        let url;
        switch (options.service) {
            case PJQ.constants.services.ORIGIN:
                url = window.location.origin;
                break;
            case PJQ.constants.services.FILES:
                url = PJQ.app.options.fileApiUrl;
                break;
            case PJQ.constants.services.APIv2:
                url = PJQ.app.options.apiV2Url;
                break;
            default:
                url = PJQ.app.options.apiUrl;
                break;
        }

        if (options.isPascal) {
            url += "/pascal";
        }

        url = url + (endpoint == null ? '' : endpoint);

        if (options.includeSessionId) {
            url = this.appendSessionId(url);
        }

        if (options.includeAccessToken) {
            url = this.appendAccessToken(url);
        }

        if (options.includeAccessKey && _.size(PJQ.app.session.get('accessKey')) > 0) {
            url = this.appendAccessKey(url);
        }

        return url;
    },
    // old/deprecated - still used in some places
    buildAPIURL: function (root, isPascal = false, includeSessionId = false, isFileAPI = false, includeAccessKey = false) {
        let url = (isFileAPI ? PJQ.app.options.fileApiUrl : PJQ.app.options.apiUrl) + (isPascal ? "/pascal" : "") + (root == null ? '' : root);
        if (includeSessionId) {
            url = this.appendSessionId(url);
        }

        if (PJQ.app.options.isDebug) {
            url = this.appendDebug(url);
        }

        if (includeAccessKey && _.size(PJQ.app.session.get('accessKey')) > 0) {
            url = this.appendAccessKey(url);
        }

        return url;
    },
    appendAccessKey: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "accessKey=" + PJQ.app.session.get('accessKey'));
    },
    appendDebug: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "debug=true");
    },
    appendSessionId: function (url) {
        return (url + (url.indexOf("?") === -1 ? "?" : "&") + "sessionId=" + PJQ.app.session.get('sessionId'));
    },
    appendAccessToken: function (url) {
        let accessToken = PJQ.app.TokenManager.getAccessToken()
        if (PJQ.app.TokenManager != null && _.size(accessToken) > 0) {
            return (url + (url.indexOf("?") === -1 ? "?" : "&") + "access_token=" + accessToken);
        }
        return url;
    },
    buildDomainURL: function (root, isPanteraDomain) {
        return isPanteraDomain ? PJQ.app.options.defaultPortalUrl : location.origin + (root == null ? '' : root);
    },
    generateEndpoint: function (endpointArr, parametersArr) {
        let result = '';
        _.each(endpointArr, function (endpointItem) {
            if (endpointItem.endpoint != null && endpointItem.endpoint.length > 0) {
                result += '/' + endpointItem.endpoint;

                result += endpointItem.value != null ? ('/' + endpointItem.value.toString()) : '';
            }
        });

        let isParamsStarted = false;
        _.each(parametersArr, function (parametersItem) {
            if (parametersItem.parameter != null && parametersItem.parameter.length > 0) {
                if (parametersItem.includeIfEmpty !== false || _.size(parametersItem.value) > 0 || typeof parametersItem.value === 'number' || typeof parametersItem.value === 'boolean') {
                    if (parametersItem.value != null) {
                        let refinedType = PJQ.helpers.objectHelpers.refinedType(parametersItem.value),
                            paramValue;
                        if (refinedType === 'array') {
                            paramValue = parametersItem.value.join(',');
                        } else if (refinedType === 'date') {
                            paramValue = parametersItem.value.toISOString();
                        } else {
                            paramValue = parametersItem.value.toString();
                        }
                        // only add the param to the result if it has a value
                        if (_.size(paramValue) > 0) {
                            result += (isParamsStarted ? "&" : "?") + parametersItem.parameter + '=' + encodeURIComponent(paramValue);
                            isParamsStarted = true;
                        }
                    }
                }
            }
        });
        return result
    },
    buildQueryParamRegex: function (name) {
        return '[?&]' + name + '=([^&#]*)';
    },
    getQueryParam: function (name, useHash = false, retainCase = false) {
        let loc = useHash ? window.location.hash : window.location.search;
        if (_.size(name) > 0 && _.size(loc) > 0) {
            let q = null;
            if (retainCase)
                q = loc.match(new RegExp(this.buildQueryParamRegex(name),'i'));
            else
                q = loc.toLowerCase().match(new RegExp(this.buildQueryParamRegex(name.toLowerCase())));
            return q && q[1].replace(/\//g, '');
        }
        return null;
    },
    removeQueryParam: function (name, useHash = false) {
        let loc = useHash ? window.location.hash : window.location.search;
        if (_.size(name) > 0 && _.size(loc) > 0) {
            let regex = new RegExp(`[?&]${name}=([^&#]*)`, 'i');
            let newLoc = loc.replace(regex, '');

            if (useHash) {
                window.location.hash = newLoc;
            } else {
                let newUrl = window.location.pathname + newLoc + window.location.hash;
                history.replaceState(null, '', newUrl);
            }
        }
    },
    queryStringToObject: function (queryString) {
        let pairs = queryString.split('&');
        return pairs.reduce((acc, pair) => {
            const [key, value] = pair.split('=');
            acc[key] = isNaN(+value) ? value : +value;
            return acc;
        }, {});
    },
    pushState: function (options) {
        if (options != null && options.url != null) {
            if (typeof options.title === 'string') {
                document.title = options.pageTitle;
            }
            window.history.pushState({}, document.title, options.url);
        }
    },
    cleanRouteParams: function () {
        if (window.location.href.indexOf('#') != -1)
            window.history.replaceState(null, null, window.location.pathname + "#" + window.location.href.split('#')[1]);
    },
    isURL: function (input) {
        let givenURL;
        try {
            givenURL = new URL(input);
        } catch (error) {
            return false;
        }
        return givenURL.protocol === "http:" || givenURL.protocol === "https:";
    }
};

PJQ.helpers.apiHelpers = {
    isDebug: false,
    getHeaders: function (service) {
        let headers = {
            PortalId: PJQ.app.session.get('portalId'),
            Debug: PJQ.helpers.apiHelpers.isDebug
        };

        let accessToken = PJQ.app.TokenManager.getAccessToken();
        if (_.size(accessToken) > 0) {
            headers.Authorization = "Bearer " + accessToken;
        }

        switch (service) {
            case PJQ.constants.services.APIv2:
                break;
            default:
                let sessionId = PJQ.app.session.get('sessionId');
                if (sessionId != null) {
                    headers.SessionId = sessionId;
                }

                if (PJQ.app.session.contact && PJQ.app.session.contact.id > 0) {
                    headers.ContactId = PJQ.app.session.contact.id;
                } else if (typeof bbContactId != 'undefined' && bbContactId > 0) {
                    headers.ContactId = bbContactId;
                }

                if (PJQ.app.session.project && PJQ.app.session.project.id > 0) {
                    headers.ProjectId = PJQ.app.session.project.id;
                } else if (typeof bbProjectId !== 'undefined' && bbProjectId > 0) {
                    headers.ProjectId = bbProjectId;
                }

                let accessKey = PJQ.app.session.get('accessKey');
                if (accessKey != null) {
                    headers.AccessKey = accessKey;
                }

                let projKey = PJQ.app.session.get('projectKey');
                if (projKey != null) {
                    headers.ProjectKey = projKey;
                }

                let contactGuid = PJQ.app.session.get('contactGuid');
                if (contactGuid != null) {
                    headers.ContactGuid = contactGuid;
                }

                if (PJQ.app.session.systemPermissions != null) {
                    headers.Perm = PJQ.app.session.systemPermissions.get('key');
                }

                if (PJQ.app.session.project != null && PJQ.app.session.project.permissions != null) {
                    headers.ProjectPerm = PJQ.app.session.project.permissions.get('key');
                }

                if (PJQ.app.session.get('masterUserId') > 0) {
                    headers.MasterUserId = PJQ.app.session.get('masterUserId');
                }
        }
        return headers;
    },
    addHeaders: function (xhr, service, extraHeaders = null) {
        let headers = PJQ.helpers.apiHelpers.getHeaders(service);
        if (extraHeaders != null) {
            for (let header in extraHeaders) {
                this.addHeader(xhr, header, headers[header]);
            }
        }
        for (let header in headers) {
            this.addHeader(xhr, header, headers[header]);
        }
    },
    addHeader: function (xhr, header, value) {
        if (value != null)
            xhr.setRequestHeader(header, value);
    }
};

PJQ.helpers.cookieHelpers = {
    getCookie: function (name) {
        let nameEQ = name + "=",
            ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    setCookie: function (name, value, days) {
        let expires = "";
        if (days >= 0) {
            let date = new Date();
            if (days > 0) {
                date.setTime(date.getTime() + (days * PJQ.constants.time.millis.ONE_DAY));
            } else {
                date.setTime(date.getTime() + (10 * 365 * PJQ.constants.time.millis.ONE_DAY));
            }
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    removeCookie: function (name) {
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    }
};

PJQ.helpers.googleMapsHelpers = {
    polyDefaults: {
        fillColor: '501400C8',
        isFill: true
    },
    generatePolyStyle: function (style) {
        style = _.defaults(style ? style : {}, this.polyDefaults);
        return '<Style><PolyStyle><color>' + (style.fillColor) + '</color><fill>' + (style.isFill ? '1' : '0') + '</fill></PolyStyle></Style>';
    }
};

PJQ.helpers.paymentHelpers = {
    validateCreditCard: function (value) {
        if (_.size(value) === 0)
            return false;

        value = value.replace(/\D/g, "");

        let nCheck = 0,
            bEven = false;
        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }
            nCheck += nDigit;
            bEven = !bEven;
        }
        return (nCheck % 10) === 0;
    },
    getCardIssuer: function (value) {
        let issuer = "unknown";
        if (_.size(value) === 0) {
            return issuer;
        }

        //JCB
        let jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');

        // American Express
        let amex_regex = new RegExp('^3[47][0-9]{0,}$');

        // Diners Club
        let diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');

        // Visa
        let visa_regex = new RegExp('^4[0-9]{0,}$'); //4

        // MasterCard
        let mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');

        // Maestro
        let maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');

        //Discover
        let discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        // get rid of anything but numbers
        value = value.replace(/\D/g, '');

        // checks per each, as their could be multiple hits
        //fix: ordering matter in detection, otherwise can give false results in rare cases
        if (value.match(jcb_regex)) {
            issuer = "jcb";
        } else if (value.match(amex_regex)) {
            issuer = "amex";
        } else if (value.match(diners_regex)) {
            issuer = "diners_club";
        } else if (value.match(visa_regex)) {
            issuer = "visa";
        } else if (value.match(mastercard_regex)) {
            issuer = "mastercard";
        } else if (value.match(discover_regex)) {
            issuer = "discover";
        } else if (value.match(maestro_regex)) {
            if (value[0] === '5') { //started 5 must be mastercard
                issuer = "mastercard";
            } else {
                issuer = "maestro"; //maestro is all 60-69 which is not something else, thats why this condition in the end
            }
        }
        return issuer;
    },
    getCardIssuerIconFAClass: function (issuer) {
        let icon;
        switch (issuer.toLowerCase()) {
            case "jcb":
                icon = 'fa-cc-jcb';
                break;
            case "amex":
                icon = 'fa-cc-amex';
                break;
            case "diners_club":
                icon = 'fa-cc-diners-club';
                break;
            case "visa":
                icon = 'fa-cc-visa';
                break;
            case "mastercard":
                icon = 'fa-cc-mastercard';
                break;
            case "maestro":
                icon = 'fa-cc-maestro';
                break;
            case "discover":
                icon = 'fa-cc-discover';
                break;
            default:
                return '';
        }
        return 'fab ' + icon;
    }
};

PJQ.helpers.colorHelpers = {
    getHexFromRGB: function (rgb) {
        if (rgb == null) {
            return null;
        } else if (rgb.indexOf('rgba') !== -1) {
            rgb = rgb.replace('rgba', 'rgb');
        }

        let rgbs = rgb.split(','),
            r = parseInt(rgbs[0].substring(4)),
            g = parseInt(rgbs[1]),
            b = parseInt(rgbs[2]);
        return "#" + PJQ.helpers.colorHelpers.componentToHex(r) + PJQ.helpers.colorHelpers.componentToHex(g) + PJQ.helpers.colorHelpers.componentToHex(b);
    },
    componentToHex: function (c) {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    },
    getRGBFromHex: function (hex) {
        if (_.indexOf(hex, '#') === -1) {
            hex = '#' + hex;
        }
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        let parsed = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return parsed ? {
            R: parseInt(parsed[1], 16),
            G: parseInt(parsed[2], 16),
            B: parseInt(parsed[3], 16)
        } : null;
    },
    idealLinkColorForBackground: function (color) {
        // if (bgColor == null) {
        // 	return '#FFF';
        // }
        // else if (bgColor.length < 5) {
        // 	bgColor += bgColor.slice(1);
        // }
        // return (bgColor.replace('#', '0x')) > (0xffffff / 2) ? '#333' : '#fff';

        let hexColor = color.replace("#", ""),
            r = parseInt(hexColor.substr(0, 2), 16),
            g = parseInt(hexColor.substr(2, 2), 16),
            b = parseInt(hexColor.substr(4, 2), 16),
            yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#333' : '#fff';
    }
};

PJQ.helpers.elementHelpers = {
    addInvisibleElement: function ($el) {
        let $b = $('body'),
            containerClass = '.invis-outer',
            $c = $b.find(containerClass);
        if (_.size($c) === 0) {
            $c = $('<div></div>', {
                class: containerClass,
                style: 'position:absolute;visibility:hidden;top:0;bottom:0;left:0;right:0;'
            });
            $b.append($c);
        }
        $c.append($el);
    },
    isElementInView: function ($el, docViewTop = null, docViewBottom = null) {
        if (docViewTop == null || docViewBottom == null) {
            docViewTop = $(window).scrollTop();
            docViewBottom = docViewTop + $(window).height();
        }
        let elementTop = $el.offset().top,
            elementBottom = elementTop + $el.height();
        return (elementBottom <= docViewBottom) && (elementTop >= docViewTop);
    }
};

PJQ.helpers.imageHelpers = {
    rotateByExif: function ($el, callback) {
        this.getExifOrientation($el, function (orientation) {
            $el.removeClass('transform-rotate-180 transform-rotate-90 transform-rotate-n-90');
            switch (orientation) {
                case 3:
                    $el.addClass('transform-rotate-180');
                    break;
                case 6:
                    $el.addClass('transform-rotate-90');
                    break;
                case 8:
                    $el.addClass('transform-rotate-n-90');
                    break;
            }
            callback();
        });
    },
    rotateElement: function ($el, degrees) {
        $el.removeClass('transform-rotate-180 transform-rotate-90 transform-rotate-n-90');
        switch (degrees) {
            case 90:
                $el.addClass('transform-rotate-90');
                break;
            case 180:
                $el.addClass('transform-rotate-180');
                break;
            case 270:
            case -90:
                $el.addClass('transform-rotate-n-90');
                break;
        }
    },
    getExifOrientation: function ($el, callback) {
        if (_.size($el) > 0) {
            let exifData = $el.data('exif');
            if (exifData != null) {
                callback(EXIF.getTag(exifData, "Orientation"));
            } else {
                EXIF.getData($el[0], function () {
                    exifData = this;
                    $el.data('exif', exifData);
                    callback(EXIF.getTag(exifData, "Orientation"));
                });
            }
        } else {
            callback(null);
        }
    }
};

PJQ.helpers.mathHelpers = {
    roundAwayFromZero(value) {
        let abs = Math.abs(value),
            rounded = (abs % 1 === 0.5) ? Math.ceil(abs) : Math.round(abs);
        return value < 0 ? -rounded : rounded;
    },
    getRandomNumber: function (max = 1) {
        return Math.floor(Math.random() * Math.floor(max));
    },
    clamp: function (num, a, b) {
        return Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
    }
};

PJQ.helpers.trigHelpers = {
    checkRectCollision: function (start, end, x, y) {
        return end.x >= x && start.x <= x && end.y >= y && start.y <= y;
    },
    distance: function (x1, y1, x2, y2) {
        let dx = x2 - x1,
            dy = y2 - y1;
        return Math.sqrt((dx * dx) + (dy * dy));
    }
};

PJQ.helpers.projectHelpers = {
    accessKeyNavigate: function (accessKey, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'accessKeys',
                    value: accessKey
                }
            ])
        }).get().done(_.bind(function (response) {
            if (response.url != null) {
                if (response.url.indexOf('Default.aspx') !== -1) {
                    window.location = response.url;
                } else if (response.url.indexOf('#') !== -1) {
                    PJQ.app.router.navigate(response.url.substring(1), {
                        trigger: true
                    });
                } else if (response.url.indexOf('/') !== -1) {
                    window.location = response.url.substring(1);
                }
            } else if (response.projectId > 0) {
                let host = window.location.origin;
                window.location = host + (host.indexOf('?') !== -1 ? '&' : '?') + 'accessKey=' + accessKey + '#projects/' + response.projectId.toString();
            } else {
                callback(response.message ? response.message : PJQ.Errors.auth.NOT_FOUND);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : PJQ.Errors.auth.NOT_FOUND);
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
                error: err,
                result: result
            });
        }, this));
    }
};

PJQ.helpers.sortHelpers = {
    regexAlpha: /[^a-zA-Z]/g,
    regexNum: /[^0-9]/g,
    sortAlphaNum: (a, b) => a.localeCompare(b, 'en', {numeric: true}),
    sortAlphaNumeric: function (a, b) {
        let aA = a.replace(PJQ.helpers.sortHelpers.regexAlpha, ""),
            bA = b.replace(PJQ.helpers.sortHelpers.regexAlpha, "");
        if (aA === bA) {
            let aN = parseInt(a.replace(PJQ.helpers.sortHelpers.regexNum, ""), 10),
                bN = parseInt(b.replace(PJQ.helpers.sortHelpers.regexNum, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    },
    commonOrder: [
        "g",
        "t",
        "d",
        "s",
        "a",
        "r",
        "m",
        "p",
        "e"
    ],
    sortCommonPageNumbers: function (a, b) {
        let regexLetters = /^[a-z]+$/i,
            aStartLetter = regexLetters.test(a[0]),
            bStartLetter = regexLetters.test(b[0]);
        if (aStartLetter && bStartLetter) {
            // if both a and b start with a letter, determine letters precedence
            // build a string for both with only the starting letters
            let aLetters = "";
            for (let i = 0; i < a.length; i++) {
                if (regexLetters.test(a[i])) {
                    aLetters += a[i].toLowerCase();
                } else {
                    break;
                }
            }

            let bLetters = "";
            for (let i = 0; i < b.length; i++) {
                if (regexLetters.test(b[i])) {
                    bLetters += b[i].toLowerCase();
                } else {
                    break;
                }
            }

            if (aLetters === bLetters) {
                // if the letters are the same, compare them alphanumeric
                return this.sortAlphaNumeric(a, b);
            }

            let aInd = -1,
                bInd = -1;
            for (let i = 0; i < this.commonOrder.length; i++) {
                if (aLetters === this.commonOrder[i]) {
                    aInd = i;
                }
                if (bLetters === this.commonOrder[i]) {
                    bInd = i;
                }
            }

            if (bInd !== -1 && aInd > bInd) {
                return 1;
            } else if (aInd !== -1 && bInd > aInd) {
                return -1;
            } else {
                // both were the same sort
                // if it got here, this means neither of them matched our commonOrder letters
                // sort alphanumeric
                return this.sortAlphaNumeric(a, b);
            }
        } else if (!aStartLetter && bStartLetter) {
            // if "b" starts with a letter and "a" does not, b is first
            return 1;
        } else if (aStartLetter && !bStartLetter) {
            // if "a" starts with a letter and "b" does not, a is first
            return -1;
        } else if (!aStartLetter && !bStartLetter) {
            // if neither "a" nor "b" start with a letter, return regular alphanumeric comparison
            return this.sortAlphaNumeric(a, b);
        }
    }
};

PJQ.helpers.browserHelpers = {
    getChromeVersion: function () {
        let raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return raw ? parseInt(raw[2], 10) : null;
    }
};

PJQ.helpers.canvasHelpers = {
    loadFont: function (font, callback) {
        document.fonts.load(font).then((_) => {
            callback(font);
        });
    },
    drawRoundRect: function (ct, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke === 'undefined') {
            stroke = true;
        }
        if (typeof radius === 'undefined') {
            radius = 5;
        }
        if (typeof radius === 'number') {
            radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
            let defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
            for (let side in defaultRadius) {
                radius[side] = radius[side] || defaultRadius[side];
            }
        }
        ct.beginPath();
        ct.moveTo(x + radius.tl, y);
        ct.lineTo(x + width - radius.tr, y);
        ct.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ct.lineTo(x + width, y + height - radius.br);
        ct.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ct.lineTo(x + radius.bl, y + height);
        ct.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ct.lineTo(x, y + radius.tl);
        ct.quadraticCurveTo(x, y, x + radius.tl, y);
        ct.closePath();
        if (fill) {
            ct.fill();
        }
        if (stroke) {
            ct.stroke();
        }
    }
};

PJQ.helpers.localStorageHelpers = {
    buildKey: function (baseKey, parts) {
        try {
            let safeParts = _.chain(parts || [])
                .compact()
                .map(function (p) { return ('' + p).replace(/[^a-zA-Z0-9\-]/g, ''); })
                .value();

            return safeParts.length > 0 ? (baseKey + '_' + safeParts.join('_')) : baseKey;
        } catch (e) {
            return baseKey;
        }
    },
    get: function (baseKey, parts) {
        try {
            return localStorage.getItem(this.buildKey(baseKey, parts));
        } catch (e) {
            return null;
        }
    },
    set: function (baseKey, parts, value) {
        try {
            localStorage.setItem(this.buildKey(baseKey, parts), value);
            return true;
        } catch (e) {
            return false;
        }
    },
    remove: function (baseKey, parts) {
        try {
            localStorage.removeItem(this.buildKey(baseKey, parts));
            return true;
        } catch (e) {
            return false;
        }
    },
    getJSON: function (baseKey, parts) {
        try {
            let raw = localStorage.getItem(this.buildKey(baseKey, parts));
            if (!raw) return null;
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    },
    setJSON: function (baseKey, parts, obj) {
        try {
            localStorage.setItem(this.buildKey(baseKey, parts), JSON.stringify(obj));
            return true;
        } catch (e) {
            return false;
        }
    }
};